import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

interface ReportCardProps {
  to: string;
  title: string;
  description: string;
  /** Etiqueta de estado: 'ready' (implementado) | 'soon' (próxima fase). */
  status?: 'ready' | 'soon';
  /** Fuente de datos, para que el operador entienda qué mira. */
  source?: string;
}

/** Tarjeta del hub de Reports — link a un sub-reporte. */
export function ReportCard({ to, title, description, status = 'ready', source }: ReportCardProps): ReactElement {
  const soon = status === 'soon';
  const content = (
    <>
      <div className="flex ai-c jc-sb gap-3">
        <h3 className="card-title">{title}</h3>
        {soon ? <span className="badge">próximamente</span> : null}
      </div>
      <p className="page-sub">{description}</p>
      {source ? <span className="report-source">fuente · {source}</span> : null}
    </>
  );

  if (soon) {
    return (
      <div className="card report-card is-soon" aria-disabled="true">
        {content}
      </div>
    );
  }
  return (
    <Link to={to} className="card report-card" data-testid={`report-card-${title}`}>
      {content}
    </Link>
  );
}
